import { ActionIcon, Group, Text, Tooltip } from '@mantine/core';

import { IconShare2 } from '@tabler/icons-react';
import Toast from '@/components/Toast';
import { isDark } from '@/utils/utils';
import { messages } from '@/consts/Messages';
import themeVariables from '@/styles/themeVariables';
import { useClipboard } from '@mantine/hooks';

const ShareButton = ({
  title,
  text,
  url,
  tooltip = true,
  label,
  className = '',
  size = 27,
  actionSize = 36,
}: {
  title: string | undefined;
  text: string | undefined;
  url: string | undefined;
  tooltip?: boolean;
  label?: any;
  className?: string;
  size?: number;
  actionSize?: number;
}) => {
  const { dark } = isDark();

  const clipboard = useClipboard({ timeout: 2000 });

  return (
    <Tooltip
      label={clipboard.copied ? messages.COPY_TO_CLIPBOARD : '공유하기'}
      display={tooltip ? 'initial' : 'none'}
      position={'bottom'}
      withinPortal
    >
      <Group
        className={className}
        sx={{
          color: themeVariables.darkMode.normal(dark),
        }}
        onClick={async () => {
          if (navigator.share) {
            try {
              await navigator.share({
                title: title,
                text: text,
                url: url,
              });
            } catch (err) {
              throw Error(err);
            }
          } else {
            clipboard.copy(url);
            Toast.info(messages.COPY_TO_CLIPBOARD);
          }
        }}
      >
        <ActionIcon size={actionSize}>
          <IconShare2
            size={size}
            color={themeVariables.darkMode.alternative(dark)}
          />
        </ActionIcon>
        <Text
          sx={(theme) => ({
            [theme.fn.smallerThan('sm')]: {
              display: 'none',
            },
          })}
        >
          {label}
        </Text>
      </Group>
    </Tooltip>
  );
};

export default ShareButton;
